import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/auth/login')
    },
    {
      path: '/',
      name: 'layout',
      component: () => import('./layout'),
      children: [
        {
          path: '/clients',
          name: 'clients',
          text: 'Clientes',
          icon: 'folder_shared',
          component: () => import('./components/clientes/Clients.vue')
        },
        {
          path: '/condominiums',
          name: 'condominiums',
          text: 'Condomínios',
          icon: 'business',
          component: () => import('./views/condominiums')
        },
        {
          path: '/checklists',
          name: 'checklists',
          text: 'Checklists',
          icon: 'check_circle',
          component: () => import('./views/checklists')
        },
        {
          path: '/datasheet',
          name: 'datasheet',
          text: 'Ficha Técnica',
          icon: 'description',
          component: () => import('./views/datasheet')
        },
        {
          path: '/accountability',
          name: 'accountability',
          text: 'Prestação de contas',
          icon: 'calculate',
          component: () => import('./views/accountability')
        },
        {
          path: '/users',
          name: 'users',
          text: 'Usuários',
          icon: 'supervised_user_circle',
          component: () => import('./views/users')
        },
        {
          path: '/profiles',
          name: 'profiles',
          text: 'Perfis de usuários',
          icon: 'recent_actors',
          component: () => import('./views/profiles')
        },
        {
          path: '/providers',
          disabled: 'disabled',
          name: 'providers',
          text: 'Terceiros',
          icon: 'build',
          component: () => import('./views/providers')
        },
        {
          path: '/documentation',
          disabled: 'disabled',
          name: 'documentation',
          text: 'Documentação',
          icon: 'folder',
          component: () => import('./views/documentation')
        },
        {
          path: '/contracts',
          disabled: 'disabled',
          name: 'contracts',
          text: 'Contratos',
          icon: 'menu_book',
          component: () => import('./views/contracts')
        },
        {
          path: '/reports',
          disabled: 'disabled',
          name: 'reports',
          text: 'Relatórios',
          icon: 'insert_chart',
          component: () => import('./views/reports')
        },
        {
          path: '/financial',
          disabled: 'disabled',
          name: 'financial',
          text: 'Financeiro',
          icon: 'show_chart',
          component: () => import('./views/financial')
        },
        {
          path: '/standardSystem',
          disabled: 'disabled',
          name: 'standardSystem',
          text: 'Padrões do sistema',
          icon: 'laptop',
          component: () => import('./views/standardSystem')
        },
        {
          path: '/dashboard',
          disabled: 'disabled',
          name: 'dashboard',
          text: 'Dashboard',
          icon: 'dashboard',
          localAction: true,
          component: () => import('./views/dashboard')
        }
      ]
    },
    {
      path: '/recuperarsenha',
      name: 'resetPwd',
      component: () => import('./views/auth/resetPassword')
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})
